import React, { useState, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import "../styles/TrueFalse.scss";

const Fillups = ({
  questions = [],
  current: propCurrent,
  setCurrent: propSetCurrent,
  answers: propAnswers,
  setAnswers: propSetAnswers,
  onNext,
  onPrev,
  mode,
  isAdmin,
  questionId,
}) => {
  const [searchParams] = useSearchParams();
  const isReviewParam = searchParams.get("review") === "true";

  const parsedQuestions = useMemo(() => {
    if (!questions) return [];
    const list = Array.isArray(questions) ? questions : [questions];
    return list.map((q) => {
      if (typeof q === "string") {
        try {
          return JSON.parse(q);
        } catch (e) {
          console.error("Error parsing question JSON:", e);
          return q;
        }
      }
      return q;
    });
  }, [questions]);

  const [internalCurrent, setInternalCurrent] = useState(0);
  const [internalAnswers, setInternalAnswers] = useState({});
  const [inputValue, setInputValue] = useState("");

  const isControlled = propCurrent !== undefined && propAnswers !== undefined;
  const current = isControlled ? propCurrent : internalCurrent;
  const answers = isControlled ? propAnswers : internalAnswers;

  const setAnswers = (val) => {
    if (isControlled) {
      propSetAnswers(val);
    } else {
      setInternalAnswers(val);
    }
  };

  const currentQ = parsedQuestions[current] || {};
  const finalQuestionId = questionId || currentQ?.question_id || currentQ?.question;
  const currentAnswerValue =
    typeof answers[finalQuestionId] === "object"
      ? answers[finalQuestionId]?.value
      : answers[finalQuestionId] || "";

  const isSubmitted =
    (mode === "quiz" &&
      (typeof answers[finalQuestionId] === "object"
        ? answers[finalQuestionId]?.isSubmitted
        : false)) ||
    mode === "review" ||
    isAdmin;

  const isCorrect =
    isSubmitted &&
    String(currentAnswerValue || "")
      .trim()
      .toLowerCase() ===
      String(currentQ?.answer || "")
        .trim()
        .toLowerCase();

  useEffect(() => {
    setInputValue(currentAnswerValue || "");
  }, [current, currentAnswerValue]);

  const handleSubmit = () => {
    if (!inputValue.trim()) return;
    setAnswers((prev) => ({
      ...prev,
      [finalQuestionId]: { value: inputValue, isSubmitted: true },
    }));
  };

  if (!parsedQuestions || parsedQuestions.length === 0) {
    return <div className="tf-empty">No questions provided.</div>;
  }

  return (
    <div className="tf-container">
      <div className="tf-card">
        <div className="tf-question">{currentQ?.question}</div>

        <div className="fillups-input-section">
          <input
            type="text"
            className={`fillups-input ${
              isSubmitted ? (isCorrect ? "correct" : "incorrect") : ""
            } ${inputValue ? "has-value" : ""}`}
            value={inputValue}
            onChange={(e) => {
              const val = e.target.value;
              setInputValue(val);

              if (!isAdmin && mode === "test" && finalQuestionId) {
                setAnswers((prev) => {
                  if (mode === "quiz") {
                    return {
                      ...prev,
                      [finalQuestionId]: {
                        value: val,
                        isSubmitted: prev[finalQuestionId]?.isSubmitted || false,
                      },
                    };
                  }
                  return {
                    ...prev,
                    [finalQuestionId]: val,
                  };
                });
              }
            }}
            disabled={isSubmitted}
            placeholder={isAdmin ? "" : "Type your answer here..."}
          />
          {mode === "quiz" && !isSubmitted && !isAdmin && (
            <button className="tf-btn submit-btn" onClick={handleSubmit}>
              Submit
            </button>
          )}
        </div>

        {isSubmitted && (
          <div
            className={`explanation-box ${isCorrect ? "correct" : "incorrect"}`}
          >
            <div className="result-header">
              {isCorrect ? "Correct!" : "Incorrect"}
            </div>
            {!isCorrect && (
              <div className="correct-answer">
                Correct Answer: <strong>{currentQ?.answer}</strong>
              </div>
            )}
            {currentQ.explanation &&
              (isReviewParam || mode === "review" || isAdmin) && (
                <div className="explanation-text">
                  <strong>Explanation:</strong> {currentQ?.explanation}
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Fillups;
